console.log('[Plugins] Начинаем загрузку RxDB плагинов...');

import { addRxPlugin } from 'rxdb';
import { RxDBUpdatePlugin } from 'rxdb/plugins/update';
import { RxDBQueryBuilderPlugin } from 'rxdb/plugins/query-builder';
// Временно отключаем dev-mode плагин для избежания ошибки DVM1
// import { RxDBDevModePlugin } from 'rxdb/plugins/dev-mode';

console.log('[Plugins] Плагины импортированы, начинаем регистрацию...');

// Инициализируем все необходимые плагины для RxDB
// Этот файл должен импортироваться первым, чтобы гарантировать,
// что плагины зарегистрированы до создания базы данных

// Добавляем плагин для поддержки операций обновления
console.log('[Plugins] Регистрируем RxDBUpdatePlugin...');
addRxPlugin(RxDBUpdatePlugin);
console.log('[Plugins] RxDBUpdatePlugin зарегистрирован');

// Добавляем плагин для поддержки query builder (sort, limit и т.д.)
console.log('[Plugins] Регистрируем RxDBQueryBuilderPlugin...');
addRxPlugin(RxDBQueryBuilderPlugin);
console.log('[Plugins] RxDBQueryBuilderPlugin зарегистрирован');

// Временно отключаем dev mode плагин в development режиме для лучшей отладки
// if (import.meta.env.DEV) {
//   console.log('[Plugins] Регистрируем RxDBDevModePlugin (dev режим)...');
//   addRxPlugin(RxDBDevModePlugin);
//   console.log('[Plugins] RxDBDevModePlugin зарегистрирован (dev режим)');
// } else {
//   console.log('[Plugins] Production режим, RxDBDevModePlugin не загружен');
// }

console.log('[Plugins] Все плагины RxDB загружены успешно');

// Экспортируем функцию для проверки инициализации
export const arePluginsInitialized = () => true; 